// src/Pages/Payment.js
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  createCheckoutSession,
  getCustomerPortalUrl
} from "../../utils/api";
import { ProjectContext } from "../../context/ProjectProvider";
import "./Payment.css";

/* Planes disponibles (solo uno por ahora) */
const packages = [
  {
    id: "pro",
    name: "Pro Plan",
    price: 495,
    currency: "USD",
    frequency: "Monthly",
    features: [
      "16,000,000 tokens input included",
      "16,000,000 tokens output included",
      "Vector-based data extraction",
      "String-based data extraction",
      "Interactive chat with your PDFs",
      "Customizable and reusable templates"
    ]
  }
];

export default function Payment() {
  const { profile } = useContext(ProjectContext);         // ← perfil con flags de Stripe
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [subscription, setSubscription] = useState({
    has: false,
    portalUrl: ""
  });

  /* 1.  Ajusta estado cuando llega el perfil */
  useEffect(() => {
    if (!profile) return;                                 // aún cargando
    setSubscription({
      has: !!profile.enabled_to_use_customer_portal,
      portalUrl: profile.customer_portal_session_url ?? ""
    });
  }, [profile]);

  /* 2. Acción del botón “Buy” / “View status” */
  const handleClick = async () => {
    // ——— Usuario CON suscripción ——————————————————————
    if (subscription.has) {
      if (subscription.portalUrl) {
        window.location.href = subscription.portalUrl;    // usa la URL que ya tenemos
        return;
      }
      // Fallback: pedimos la URL al backend (no debería dar 404)
      try {
        const { portal_session_url } = await getCustomerPortalUrl();
        window.location.href = portal_session_url;
      } catch (err) {
        console.error("Error obtaining portal URL:", err);
        alert("Could not open billing portal. Please try again.");
      }
      return;
    }

    // ——— Usuario SIN suscripción → inicia checkout ——————
    setLoading(true);
    try {
      const { checkout_session_url } = await createCheckoutSession();
      window.location.href = checkout_session_url;
    } catch (err) {
      console.error("Error starting checkout:", err);
      alert("The payment process could not be initiated. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  /* 3. UI */
  return (
    <div className="payment-page">
      {/* Botón de cierre en la esquina superior derecha */}
      <button
        className="payment-page__close"
        onClick={() => navigate(-1)}
        title="Cerrar"
      >
        <i className="bi bi-x"></i>
      </button>

      <h1 className="payment-page__title">Upgrade your plan</h1>

      <div className="w-full max-w-md">
        {packages.map((pkg) => (
          <div key={pkg.id} className="pricing-card">
            {/* Nombre y precio */}
            <h2 className="pricing-card__name">{pkg.name}</h2>
            <p className="pricing-card__price">
              <span className="pricing-card__price-amount">${pkg.price}</span>
              <span className="pricing-card__price-period">/{pkg.frequency}</span>
            </p>

            {/* Características */}
            <ul className="pricing-card__features">
              {pkg.features.map((f) => (
                <li key={f} className="pricing-card__feature">
                  <i className="bi bi-check2-square"></i>
                  <span>{f}</span>
                </li>
              ))}
            </ul>

            {/* Botón Comprar / Ver estado */}
            <button
              className="pricing-card__btn"
              disabled={loading || !profile}              // se desactiva hasta tener perfil
              onClick={handleClick}
            >
              {subscription.has
                ? "View status"
                : loading
                ? "Processing…"
                : "Buy"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

